import { render, staticRenderFns } from "./DotDropdown.vue?vue&type=template&id=d5370c02&scoped=true"
import script from "./DotDropdown.vue?vue&type=script&lang=js"
export * from "./DotDropdown.vue?vue&type=script&lang=js"
import style0 from "./DotDropdown.vue?vue&type=style&index=0&id=d5370c02&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5370c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5370c02')) {
      api.createRecord('d5370c02', component.options)
    } else {
      api.reload('d5370c02', component.options)
    }
    module.hot.accept("./DotDropdown.vue?vue&type=template&id=d5370c02&scoped=true", function () {
      api.rerender('d5370c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DotDropdown.vue"
export default component.exports